module.exports = __webpack_public_path__ + "media/images/brand/original/MARQUESBRANDINGCO LOGO SOCIALMEDIA_DESTAQUES-b5cba432c8e50fa5da289e21a460d0b8.png";